<template>
  <div>
    <vx-card title="Add User" subtitle="Isi data dengan benar">
      <template slot="actions">
          <div class="vx-row">
            <div class="vx-col w-full m-0">
              <vs-button icon-pack="feather" class="mt-2" @click="saveData">Simpan Data</vs-button>
              <vs-button to="/users" class="ml-4 mt-2" type="border" color="danger">Kembali</vs-button>
            </div>
          </div>
      </template>
      <div slot="no-body" class="p-6">
        <div class="divider mb-4"></div>
        <div class="vx-row">
          <div class="vx-col md:w-1/2 w-full">
            <div class="w-full">
              <label class="text-sm opacity-75">Nama Lengkap</label>
              <vs-input class="w-full" v-model="form.name" name="name" />
              <span class="text-danger text-sm"  v-show="errors.has('name')">{{ errors.first('name') }}</span>
            </div>
            <div class="vx-row mt-4">
              <div class="vx-col md:w-1/2">
                <label class="text-sm opacity-75">Username</label>
                <vs-input class="w-full" v-model="form.username" v-validate="'required'" name="username" />
                <span class="text-danger text-sm"  v-show="errors.has('username')">{{ errors.first('username') }}</span>
              </div>
              <div class="vx-col md:w-1/2">
                <label class="text-sm opacity-75">Password</label>
                <vs-input class="w-full" type="password" v-model="form.password" v-validate="'required'" name="password" />
                <span class="text-danger text-sm"  v-show="errors.has('password')">{{ errors.first('password') }}</span>
              </div>
            </div>

            <div class="vx-row mt-4">
              <div class="vx-col md:w-1/2">
                <label class="text-sm opacity-75">Email</label>
                <vs-input class="w-full" v-model="form.email" v-validate="'required|email|min:3'" name="email" />
                <span class="text-danger text-sm"  v-show="errors.has('email')">{{ errors.first('email') }}</span>
              </div>
              <div class="vx-col md:w-1/2">
                <label class="text-sm opacity-75">No. Handphone</label>
                <vs-input class="w-full" v-model="form.phone" v-validate="'numeric'" name="phone" />
                <span class="text-danger text-sm"  v-show="errors.has('phone')">{{ errors.first('phone') }}</span>
              </div>
            </div>
          </div>
          <div class="vx-col md:w-1/2 w-full">
            <label class="text-sm opacity-75">Foto Profil</label>
            <div class="flex items-start flex-col sm:flex-row">
              <img :src="url" class="rounded mr-4" width="180" height="180" />
              <div>
                <input type="file" @change="addAvatar" class="hidden" ref="update_logo_input" accept="image/*">
                <vs-button  @click="$refs.update_logo_input.click()" class="mr-4 mb-2" type="filled" icon-pack="feather" icon="icon-edit"></vs-button>
                <vs-button @click="removeAvatar()" type="border" color="danger" icon-pack="feather" icon="icon-trash"></vs-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
// Store Module
import moduleEmployee from '@/store/employee/moduleEmployee.js'

export default {
  data () {
    return {
      form:{
        name: null,
        username: null,
        password: null,
        email: null,
        phone: null,
        avatar: null
      },

      url: null
    }
  },
  created () {
    if (!moduleEmployee.isRegistered) {
      this.$store.registerModule('employee', moduleEmployee)
      moduleEmployee.isRegistered = true
    }
  },
  computed: {
    validateForm () {
      return !this.errors.any() &&
        this.name !== '' &&
        this.username !== '' &&
        this.password !== '' &&
        this.email !== ''  &&
        this.phone !== ''
    },
  },
  methods: {
    addAvatar (e) {
      const file = e.target.files[0]
      this.url = URL.createObjectURL(file)
      this.form.logo = file
    },

    removeAvatar () {
      this.url = null
      this.form.logo = null
    },

    saveData () {
      const self      = this
      const userData  = this.$store.state.AppActiveUser

      this.$validator.validateAll().then(result => {
        if (result) {

          const formData = new FormData()
          formData.set('company_id', userData.company.id)
          formData.set('name', self.form.name)
          formData.set('username', self.form.username)
          formData.set('password', self.form.password)
          formData.set('role', 'User')
          formData.set('email', self.form.email)
          formData.set('phone', self.form.phone)
          formData.append('avatar', self.form.avatar)

          this.$store.dispatch('user/createUser', formData)
            .then(function () {
              self.$vs.notify({
                color: 'success',
                title: 'Berhasil',
                text: 'Akun Profil berhasil di perbarui'
              })
              self.$router.push('/users')
            })
            .catch(err => {
              self.$vs.notify({
                color: 'danger',
                title: 'Oops..',
                text: err.response.data.message
              })
            })
        }
      })
    }
  }
}
</script>

<style lang="scss">
.divider {
  background: #E0E0E0;
  height: 1px;
}
</style>
